var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    fill: "#616C85"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0c2.49 0 4.5 2.01 4.5 4.5S11.49 9 9 9 4.5 6.99 4.5 4.5 6.51 0 9 0zM3.937 11.25h10.126A3.938 3.938 0 0118 15.188v1.937a2 2 0 01-2 2H2a2 2 0 01-2-2v-1.938a3.938 3.938 0 013.938-3.937z",
    fillRule: "evenodd"
  })));
}
export default SvgProfile;